import React, { useReducer, useContext, useState } from "react";
// import axios from "axios";
import CampaignContext from "./CampaignContext";
import CampaignReducer from "./CampaignReducer";
import {
  SET_DISPLAY_CONTENT,
  SET_LANDER_URL,
  AGENCY_ACCOUNT,
  FORM_DATA,
  FORM_ERROR,
  SEARCH_CHECKOUT,
  CHECKOUT_LOADING,
  CHECKOUT_DATA,
  CHECKOUT_ERROR,
  GET_CAMPAIGN,
  GET_CAMPAIGNS,
  CAMPAIGN_ERROR,
  RESET_CAMPAIGN,
} from "../types";
import qs from "query-string";

import AuthContext from "../auth/AuthContext";
import LayoutContext from "../layout/LayoutContext";
import axios from "../../axiosinstance";

const CampaignState = (props) => {
  // CAMPAIGN (Section 2 & 3)
  const default_form_data = {
    media_buyer: "",
    laptop: "",
    domain: "",
    angle: "",
    product_id: "",
    deals: {
      recommended: "",
      super_saver: "",
    },
    presell: {},
    upsell: {},
    language: "en",
    bm_account: "",
    ad_account: "",
    pixel_id: "",
    pixel_access_token: "",
    posting_store: "",
    status: "ACTIVE",
    paused_at: "",
    store_name: "",
    store_logo: ""
  };
  const default_form_error = {
    media_buyer: "",
    laptop: "",
    domain: "",
    angle: "",
    product_id: "",
    presell: {},
    upsell: {},
    bm_account: "",
    ad_account: "",
    pixel_id: "",
    pixel_access_token: "",
    posting_store: "",
  };

  // CHECKOUT (Section 4)
  const default_reviews = {
    avatar: "",
    comment: "",
    name: "",
    location: "",
  };
  const default_checkout_data = {
    product_id: "",
    images: {
      logo: "",
      banner: ["", "", ""],
    },
    reviews: [],
  };
  const default_checkout_error = {
    images: "",
    reviews: "",
  };

  const initialState = {
    display_content: "",
    campaigns: null,
    campaigns_count: 0,
    campaign_error: null,
    lander_url: null,
    selected_campaign: null,
    agency_account: false,
    form_data: default_form_data,
    form_error: default_form_error,
    selected_checkout: null,
    checkout_loading: false,
    checkout_data: null,
    checkout_error: null,
  };

  const [lander_imported, setLanderImported] = useState(false);

  const [state, dispatch] = useReducer(CampaignReducer, initialState);
  const { user } = useContext(AuthContext);
  const { setLoading, setAlert } = useContext(LayoutContext);

  const setDisplayContent = (page) => {
    dispatch({
      type: SET_DISPLAY_CONTENT,
      payload: page,
    });
  };

  const setLanderUrl = (url) => {
    dispatch({
      type: SET_LANDER_URL,
      payload: url,
    });
  };

  const importLander = async () => {
    const lander_url = state.lander_url;

    if (lander_url) {
      setLoading(true);

      try {
        const res = await axios.post("/api/campaigns/pages", {
          lander_url,
          username: user.name,
        });

        setLanderImported(true);

        dispatch({
          type: FORM_DATA,
          payload: res.data,
        });
      } catch (err) {
        console.log(err);
        setAlert(err.response.data.msg, "error");
      }

      setLoading(false);
    }
  };

  const toggleAgencyAccount = () => {
    dispatch({
      type: AGENCY_ACCOUNT,
      payload: !state.agency_account,
    });
  };

  const resetCampaignData = () => {
    dispatch({
      type: RESET_CAMPAIGN,
      payload: {
        form_data: default_form_data,
        checkout_data: default_checkout_data,
      }
    })
  }

  const setFormData = (data) => {
    dispatch({
      type: FORM_DATA,
      payload: data,
    });
  };

  const setFormError = (error) => {
    dispatch({
      type: FORM_ERROR,
      payload: error,
    });
  };

  const searchCheckout = async (product_id) => {
    if (product_id) {
      dispatch({
        type: CHECKOUT_LOADING,
      });

      // Initialize Selected Checkout Object
      let selected_checkout = null;

      try {
        // Get Existing Checkout
        const res = await axios.get(`/api/checkout/product/${product_id}`);

        // Save Selected (Original) Checkout Object in State
        selected_checkout = JSON.parse(JSON.stringify(res.data));

        dispatch({
          type: SEARCH_CHECKOUT,
          payload: {
            selected_checkout,
            data: res.data,
          },
        });
      } catch (err) {
        // New Checkout
        let form_data = JSON.parse(JSON.stringify(default_checkout_data));
        form_data.product_id = parseInt(product_id);

        dispatch({
          type: SEARCH_CHECKOUT,
          payload: {
            selected_checkout,
            data: form_data,
          },
        });
      }

      // Reset Checkout Error Form
      dispatch({
        type: CHECKOUT_ERROR,
        payload: default_checkout_error,
      });
    }
  };

  const setCheckoutData = (data) => {
    dispatch({
      type: CHECKOUT_DATA,
      payload: data,
    });
  };

  const setCheckoutError = (error) => {
    dispatch({
      type: CHECKOUT_ERROR,
      payload: error,
    });
  };

  const getCampaign = async (domain, campaign_id) => {
    setLoading(true);

    try {
      const res = await axios.get(`/api/campaigns/${domain}/${campaign_id}`);
      searchCheckout(res.data.campaign.product_id);

      dispatch({
        type: GET_CAMPAIGN,
        payload: res.data,
      });
    } catch (err) {
      // Not Found - Return To Search Campaign Page
      console.log(err);
      window.location.replace(`${window.location.origin}/campaign`);
    }

    setLoading(false);
  };

  const getCampaigns = async (
    page,
    pageSize,
    orderBy,
    orderDirection,
    searchText
  ) => {
    try {
      const params = {
        page,
        pageSize,
        orderBy,
        orderDirection,
        searchText,
      };
      const params_encoded = qs.stringify(params, {
        arrayFormat: "comma",
      });

      const res = await axios.get(`/api/campaigns?${params_encoded}`);
      dispatch({
        type: GET_CAMPAIGNS,
        payload: res.data,
      });

      return res.data;
    } catch (err) {
      dispatch({
        type: CAMPAIGN_ERROR,
        payload: err.response,
      });
    }
  };

  const updateCheckout = async (cchanges) => {
    const checkout_data = state.checkout_data;

    let upload = true;

    if (Object.keys(checkout_data).includes("_id") && !cchanges) {
      upload = false;
    }

    if (upload) {
      await axios.post("/api/checkout", {
        form_data: checkout_data,
        username: user.name,
      });
    }
  };

  const createCampaign = async (cchanges) => {
    setLoading(true);

    try {
      state.form_data["angle"] = state.form_data["angle"].trim();

      const campaign = await axios.post("/api/campaigns/", {
        form_data: state.form_data,
      });

      await updateCheckout(cchanges);

      // Redirect To Edit Campaign Page
      setLanderImported(false);
      window.scrollTo(0, 0);
      setAlert("Campaign Created.", "success");
      window.location.replace(
        `${window.location.origin}/campaign/active/${campaign.data.domain}/${campaign.data.campaign_id}`
      );
    } catch (err) {
      console.log(err);
      setAlert(err.response.data.msg, "error");
    }

    setLoading(false);
  };

  const updateCampaign = async (pchanges, cchanges) => {
    setLoading(true);

    if (!pchanges && !cchanges && !lander_imported) {
      setAlert("No Changes Has Been Made.", "info");
    } else {
      try {
        if (pchanges) {
          state.form_data["angle"] = state.form_data["angle"].trim();

          await axios.put(`/api/campaigns/${state.form_data.campaign_id}`, {
            form_data: state.form_data,
          });
        }

        await updateCheckout(cchanges);

        // Refresh Edit Campaign Page
        setLanderImported(false);
        window.scrollTo(0, 0);
        setAlert("Campaign Saved.", "success");
        getCampaign(state.form_data.domain, state.form_data.campaign_id);
      } catch (err) {
        setAlert(err.response.data.msg, "error");
      }
    }

    setLoading(false);
  };

  return (
    <CampaignContext.Provider
      value={{
        default_reviews,

        display_content: state.display_content,
        campaigns: state.campaigns,
        campaigns_count: state.campaigns_count,

        lander_url: state.lander_url,
        selected_campaign: state.selected_campaign,
        agency_account: state.agency_account,
        form_data: state.form_data,
        form_error: state.form_error,

        selected_checkout: state.selected_checkout,
        checkout_loading: state.checkout_loading,
        checkout_data: state.checkout_data,
        checkout_error: state.checkout_error,

        setDisplayContent,
        setLanderUrl,
        importLander,

        toggleAgencyAccount,
        setFormData,
        setFormError,
        resetCampaignData,

        searchCheckout,
        setCheckoutData,
        setCheckoutError,

        getCampaign,
        getCampaigns,
        createCampaign,
        updateCampaign,
      }}
    >
      {props.children}{" "}
    </CampaignContext.Provider>
  );
};

export default CampaignState;
